import React from "react";
import "react-dropdown/style.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import appStore from '../assets/download_on_app_store.svg';
import googlePlay from '../assets/google-play-badge.png';
import ur1 from "../assets/logo-large.jpg";
import { logout } from "../common/slices/auth";
import { androidFilepath } from "../constants";
import { BlackButton } from "./Buttons";
import Row from "./Row";
import { H1, P, P2 } from "./Typography";

const Form = styled.div`
    display: flex;
    gap: 1rem;
    background: white;
    padding: 0 5rem;
    flex-direction: column;
    min-width: 300px;
    max-width: 500px;
    border-left: 1px solid #b9b9b9;

    @media(max-width: 920px) {
        border-left: none;
        flex: 1;
    }
`;

const Container = styled(Row)`
    flex: 1;
    background: white;
    align-items: center;
    justify-content: center;
    display: flex;
    gap: 5rem;

    @media(max-width: 920px) {
        flex-wrap: wrap;
        align-content: center;
    }
`;

const Logo = styled.img`
    display: flex;
    flex-shrink: 0;
    align-self: center;
`;

const DLIcon = styled.img`
    cursor: pointer;
`;

const AccessDenied = () => {
    const dispatch = useDispatch();
    const nav = useNavigate();

    const onLogout = async () => {
        await dispatch(logout());
        nav('/');
    };

    return (
        <Container>
            <Logo src={ur1} style={{ height: '200px' }} />
            <Form>
                {/* <Divider.Horizontal /> */}
                <H1>Access Denied</H1>
                <P>Oops! It seems like you don't have the necessary permissions to access this application.</P>

                <P2>Admins Only</P2>
                <P>This application is restricted to users with Admin roles. If you believe you should have access, please contact your administrator for assistance.</P>

                <P2>Mobile Application</P2>
                <P>For Foreman and Workers:<br />
                    To access the application, please download the mobile app from one of the links below:</P>
                <Row>
                    <DLIcon src={appStore} onClick={() => window.open('https://apps.apple.com/us/app/united-roofing/id6478508212', '_blank')} />
                    <DLIcon src={googlePlay} style={{ height: '40px' }} onClick={() => window.open(androidFilepath, '_blank')} />
                </Row>
                <BlackButton onClick={onLogout}>
                    Logout
                </BlackButton>
            </Form>
        </Container>
    );
};

export default AccessDenied;
